import AxiosConfig from "../AxiosConfig";

/**
 *
 * @param orgSettings
 * @returns {*|null|string}
 */
export const getUploadResourceUrl = (resourceUrl) => {
  if (resourceUrl) {
    if (resourceUrl instanceof File) {
      return URL.createObjectURL(resourceUrl);
    }

    if (resourceUrl.startsWith("http")) {
      return resourceUrl;
    }
    return AxiosConfig.getEndpointAddress() + "/" + resourceUrl;
  }

  return null;
};

/**
 *
 * @param slug
 * @param widgetHost
 * @returns {`${string}//${string}/${string}`}
 */
export const getPublicWidgetUrl = (slug, widgetHost) => {
  const url = new URL(window.location.origin);
  const _widgetHost = widgetHost || process.env.PUBLIC_WIDGET_HOST;
  return `${url.protocol}//${_widgetHost}/${slug}`;
};
